import { apiGet } from '../support/helpers/ApiConnection.Helper';
import ActivityLogResponseDataModel from '../data-models/admin/access-control/ActivityLogResponse.DataModel';
import ActivityTypeDataModel from '../data-models/admin/access-control/ActivityType.DataModel';
import UserAdminTableDataModel from '../data-models/UserAdminTableDataModel';

export interface ActivityLogFilters {
    userId?: number;
    activityTypeId?: number;
    dateFrom?: string;
    dateTo?: string;
}

export function getActivityLog(
    filters: ActivityLogFilters,
    abortSignal: AbortSignal,
): Promise<ActivityLogResponseDataModel> {
    const queryParams: Array<string> = [];

    if (filters.userId) {
        queryParams.push(`userId=${filters.userId}`);
    }
    if (filters.activityTypeId) {
        queryParams.push(`activityTypeId=${filters.activityTypeId}`);
    }
    if (filters.dateFrom) {
        queryParams.push(`dateFrom=${encodeURIComponent(filters.dateFrom)}`);
    }
    if (filters.dateTo) {
        queryParams.push(`dateTo=${encodeURIComponent(filters.dateTo)}`);
    }

    const queryString = queryParams.join('&');
    const search = queryString.length > 0 ? '?' + queryString : '';

    return apiGet<ActivityLogResponseDataModel>(`/activity-log${search}`, abortSignal);
}

export function getActivityLogUsers(abortSignal: AbortSignal): Promise<Array<UserAdminTableDataModel>> {
    return apiGet<Array<UserAdminTableDataModel>>('/activity-log/users', abortSignal);
}

export function getActivityTypes(abortSignal: AbortSignal): Promise<Array<ActivityTypeDataModel>> {
    return apiGet<Array<ActivityTypeDataModel>>('/activity-types', abortSignal);
}
